import { render, staticRenderFns } from "./TRT_YearFilter.vue?vue&type=template&id=b3974f3a&scoped=true&"
import script from "./TRT_YearFilter.vue?vue&type=script&lang=js&"
export * from "./TRT_YearFilter.vue?vue&type=script&lang=js&"
import style0 from "./TRT_YearFilter.vue?vue&type=style&index=0&id=b3974f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3974f3a",
  null
  
)

export default component.exports